
export class NetworkSubordinate {
	constructor(public Network: any) {
	}
}
